import {
  IncentiveEvaluationMessage,
  IncentiveEvaluationMessages,
} from 'components/incentive-evaluation-messages/incentive-evaluation-messages';

export const StyledIncentiveEvaluationMessages = IncentiveEvaluationMessages.withConfig({
  borderWidth: 'px',
  borderColor: Styles.color.red,
  padding: '$4',
  alignItems: 'center',
});

export const StyledIncentiveEvaluationMessage = IncentiveEvaluationMessage.withConfig({
  borderWidth: 'px',
  borderColor: Styles.color.red,
  padding: '$4',
});
